<script>
    export let loggedIn = false;

    import { Routes, pushRoute } from '../router';
    import { page } from '../stores';

    function onToTerms() {
        pushRoute(Routes.TERMS_AND_CONDITIONS);
    }
</script>

<div id="outer">
    {#if loggedIn}
        <div id="links">
            <a class="link" href="mailto:help@campuspano.io" target="_blank">Help</a>
            <p class="link" on:click={onToTerms} >Terms</p>
        </div>
    {/if}
    <span>&copy; Plunge Studios</span>
</div>

<style>
    #outer {
        padding: 20px;
        flex-shrink: 0;
        background-color: var(--off-black);
        color: var(--dark-grey);
        text-align: center;
        box-shadow: var(--box-shadow);
        display: flex;
        flex-direction: column;
    }

    #links {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        align-items: baseline;
        margin-bottom: 10px;
    }

    .link {
        padding: 0px 5px;
    }

    a {
        color: var(--dark-grey);
    }

    a:hover {
        cursor: pointer;
        color: var(--light-grey);
    }

    p {
        text-decoration: underline;
        margin-top: 10px;
        color: var(--dark-grey);
    }

    p:hover {
        cursor: pointer;
        color: var(--light-grey);
    }
</style>
